<template>
	<el-dialog class="group-add-dialog" title="通过群号添加群聊" width="560px" :visible.sync="visible" append-to-body>
		<div class="search-area">
			<el-input v-model="searchText" placeholder="请输入群号" size="small" @keyup.enter.native="onSearch">
				<i slot="prefix" class="el-icon-search el-input__icon"></i>
			</el-input>
		</div>
		<div class="result-area">
			<no-data-tip v-if="isNoData" :tip="noDataTip"></no-data-tip>
			<div v-else-if="group" class="group-card">
				<div class="item">
					<div class="avatar">
						<head-image :name="group.showGroupName" :url="group.headImageThumb"></head-image>
					</div>
					<div class="group-info">
						<div class="name-row">
							<div class="group-name-text">{{ group.showGroupName }}</div>
						</div>
						<div class="text-info">
							<div v-if="group.groupQq">群号: {{ group.groupQq }}</div>
						</div>
					</div>
					<span class="status-tip" v-if="isInGroup(group.id)">已加入</span>
					<span class="status-tip waiting" v-else-if="isWaitingApprove(group)">等待审批</span>
					<el-button v-else-if="group.needCheck" type="primary" size="mini"
						@click.stop="onApplyJoin(group)">申请加入</el-button>
					<el-button v-else type="primary" size="mini" @click.stop="onJoinByQq(group)">加入群聊</el-button>
				</div>
			</div>
			<no-data-tip v-else tip="请输入群号后搜索"></no-data-tip>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="onClose">关 闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
import NoDataTip from '../common/NoDataTip.vue';
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "groupAddDialog",
	components: { NoDataTip, HeadImage },
	data() {
		return {
			visible: false,
			searchText: "",
			isNoData: false,
			group: null
		}
	},
	computed: {
		noDataTip() {
			if (!this.searchText) {
				return "请输入群号后搜索";
			}
			return `未搜索到群号为 '${this.searchText}' 的群聊`;
		}
	},
	methods: {
		open() {
			this.visible = true;
			this.searchText = "";
			this.isNoData = false;
			this.group = null;
		},
		onClose() {
			this.visible = false;
		},
		onSearch() {
			const qq = (this.searchText || "").trim();
			if (!qq) {
				this.$message.warning("请输入群号");
				return;
			}
			this.$http({
				url: "/group/findByQq",
				method: "GET",
				params: {
					groupQq: qq
				}
			}).then((data) => {
				const g = data && (data.data !== undefined ? data.data : data);
				this.group = g;
				this.isNoData = !this.group;
			}).catch(() => {
				this.group = null;
				this.isNoData = true;
			})
		},
		isInGroup(groupId) {
			return this.groupStore.isGroup(groupId);
		},
		isWaitingApprove(group) {
			if (!group || !group.id) return false;
			const mineId = this.userStore.userInfo.id;
			return this.groupRequestStore.requests.some(req =>
				req.groupId === group.id &&
				req.sendId === mineId &&
				req.status === this.$enums.REQUEST_STATUS.PENDING
			);
		},
		onApplyJoin(group) {
			this.$http({
				url: "/group/request/apply",
				method: "POST",
				data: {
					groupId: group.id,
					remark: ""
				}
			}).then((request) => {
				if (request.status == this.$enums.REQUEST_STATUS.APPROVED) {
					this.$message.success("已加入群聊");
					this.groupStore.loadGroup();
					this.visible = false;
				} else {
					// PENDING：已发起申请，加入本地申请列表，便于后续展示“等待审批”
					if (request.status == this.$enums.REQUEST_STATUS.PENDING && this.groupRequestStore && this.groupRequestStore.addRequest) {
						this.groupRequestStore.addRequest(request);
					}
					this.$message.success("已提交申请，请等待群管理员审核");
					this.visible = false;
				}
			});
		},
		onJoinByQq(group) {
			this.$http({
				url: "/group/joinByQq",
				method: "POST",
				data: {
					groupQq: group.groupQq
				}
			}).then(() => {
				this.$message.success("已加入群聊");
				this.groupStore.loadGroup();
				this.visible = false;
			});
		}
	}
}
</script>

<style scoped lang="scss">
.group-add-dialog {
	.search-area {
		margin-bottom: 16px;
	}

	.result-area {
		min-height: 260px;

		.group-card {
			margin-top: 8px;

			.item {
				height: 65px;
				display: flex;
				position: relative;
				padding-left: 15px;
				align-items: center;
				padding-right: 25px;

				.avatar {
					flex-shrink: 0;
				}

				.group-info {
					margin: 0 15px;
					flex: 1;
					display: flex;
					flex-direction: column;
					overflow: hidden;

					.name-row {
						display: flex;
						align-items: center;
						white-space: nowrap;

						.group-name-text {
							font-size: 16px;
							line-height: 25px;
							font-weight: 600;
						}
					}

					.text-info {
						display: flex;
						flex-direction: row;
						font-size: 12px;
						line-height: 20px;
						white-space: nowrap;
						color: var(--im-text-color-light);
					}
				}

				.status-tip {
					color: var(--im-text-color-light);
					font-size: var(--im-font-size-small);

					&.waiting {
						color: var(--im-color-warning);
					}
				}
			}
		}
	}
}
</style>

